import type { Jet } from '~/jet';
import type { LoggerFactory } from '@amp/web-apps-logger';
import type { ExternalUrlAction } from '~/jet/models';

export type Dependencies = {
    jet: Jet;
    logger: LoggerFactory;
};

export function registerHandler(dependencies: Dependencies) {
    const { jet, logger } = dependencies;

    const log = logger.loggerFor(
        'jet/action-handlers/open-external-url-action',
    );
    const windowFeatures = 'noopener,noreferrer';

    jet.onAction('openExternalURLAction', async (action: ExternalUrlAction) => {
        log.info('received external URL:', action);
        window?.open(action.url, '_blank', windowFeatures);
        return 'performed';
    });
}
